import { render, staticRenderFns } from "./MagicCubeSetting.vue?vue&type=template&id=73cb8abc&scoped=true"
import script from "./MagicCubeSetting.vue?vue&type=script&lang=js"
export * from "./MagicCubeSetting.vue?vue&type=script&lang=js"
import style0 from "./MagicCubeSetting.vue?vue&type=style&index=0&id=73cb8abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb8abc",
  null
  
)

export default component.exports